import { apiClient, unwrapApiResult } from '@/lib/openapi-client';
import type {
  AdminManagedSpendRead,
  PaginatedResponse,
} from '@/types/generated';
import type { components } from '@/types/generated/openapi';

const BASE = '/api/v1/admin/managed-spend';

export type ManagedSpendSortField =
  components['schemas']['ManagedSpendSortField'];

export type SortDirection = 'asc' | 'desc';

// A Record, so a field the backend adds fails the build until it is listed here.
const SORT_FIELDS: Record<ManagedSpendSortField, true> = {
  organization: true,
  last_30_days_usd: true,
  last_12_months_usd: true,
  all_time_usd: true,
};

export const MANAGED_SPEND_SORT_FIELDS = Object.keys(
  SORT_FIELDS,
) as ManagedSpendSortField[];

// The endpoint's largest page.
export const MANAGED_SPEND_EXPORT_PAGE = 100;

export interface ManagedSpendSort {
  sort_by: ManagedSpendSortField;
  sort_dir: SortDirection;
}

export interface ListAdminManagedSpendParams extends ManagedSpendSort {
  limit: number;
  offset: number;
}

const list = (
  params: ListAdminManagedSpendParams,
): Promise<PaginatedResponse<AdminManagedSpendRead>> =>
  unwrapApiResult(apiClient.GET(BASE, { params: { query: params } }));

const listAll = async (
  sort: ManagedSpendSort,
): Promise<AdminManagedSpendRead[]> => {
  const rows: AdminManagedSpendRead[] = [];
  for (;;) {
    const page = await list({
      ...sort,
      limit: MANAGED_SPEND_EXPORT_PAGE,
      offset: rows.length,
    });
    rows.push(...page.items);
    if (page.items.length === 0 || rows.length >= page.total) return rows;
  }
};

export const adminManagedSpendApi = { list, listAll } as const;
